<template>
    <c-dialog ref="dialog" title="推送报告详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <span v-if="saasName" class="m-detail-saas">{{saasName}}</span>
            </div>
        </template>

        <module>
            <module-col size="320">
                <c-detail class="m-detail-form">
                    <c-detail-item label="所属商户">
                        {{saasName || '-'}}
                    </c-detail-item>
                    <c-detail-item label="场次">
                        {{master.auction_batch_no || '-'}}
                    </c-detail-item>
                    <c-detail-item label="推送总台数">
                        {{master.total_cnt == null ? '-' : master.total_cnt}}
                    </c-detail-item>
                    <c-detail-item label="报告生成时间">
                        {{master.report_gen_time || '-'}}
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <module-tab name="渠道汇总" enable-flex>
                    <div class="m-detail-box">
                        <c-table :data="summaryList" border :paging="false">
                            <c-table-column label="推送渠道" min-width="160">
                                <template #default="{data}">{{data.channel_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="推送总数" width="100">
                                <template #default="{data}">{{data.total}}</template>
                            </c-table-column>
                            <c-table-column label="推送成功" width="100">
                                <template #default="{data}">
                                    <span style="color: #19be6b;">{{data.success}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="推送失败" width="100">
                                <template #default="{data}">
                                    <span style="color: #ed3f14;">{{data.fail}}</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>

                <module-tab name="推送明细" enable-flex>
                    <div class="m-detail-box">
                        <c-table :data="detailList" border :paging="false">
                            <c-table-column label="推送渠道" width="130">
                                <template #default="{data}">{{data.channel_name || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="产品信息" width="280">
                                <template #default="{data}">
                                    <c-state v-if="data.level_type" tag dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                                    <span>{{data.product_info || '-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="背贴码" width="140">
                                <template #default="{data}">{{data.produce_unique_code || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="IMEI" width="150">
                                <template #default="{data}">{{data.produce_imei || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="推送价格" width="100">
                                <template #default="{data}">
                                    <span style="color: #e53e3e;">{{formatPrice(data.push_price)}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="推送状态" width="90">
                                <template #default="{data}">
                                    <c-state dict="PUSH_STATE" :value="data.push_state"></c-state>
                                </template>
                            </c-table-column>
                            <c-table-column label="失败原因" min-width="160">
                                <template #default="{data}">{{data.fail_reason || '-'}}</template>
                            </c-table-column>
                            <c-table-column label="推送时间" width="160">
                                <template #default="{data}">{{data.create_date || '-'}}</template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>
    </c-dialog>
</template>

<script>
export default {
    name: 'erpAuctionPushReportDetail',

    data() {
        return {
            saasId: '',
            saasName: '',
            reportId: '',
            master: {},
            summaryList: [],
            detailList: []
        }
    },

    methods: {
        /*********打开抽屉（data=列表行）**********/
        open(data = {}) {
            this.saasId = data.saas_id;
            this.saasName = data.saas_name || '';
            this.reportId = data.id;
            this.master = {};
            this.summaryList = [];
            this.detailList = [];
            this.$refs.dialog.open();
            this.loadDetail();
        },

        /*********加载报告详情**********/
        loadDetail() {
            this.request({
                url: '/sale/auction/report/push/ops/detail',
                data: {
                    merchant_id: this.saasId,
                    id: this.reportId
                },
                loading: true,
                success: data => {
                    this.master = data.master || {};
                    this.detailList = data.detail_list || [];
                    this.summaryList = this.parseSummary(this.master.channel_summary_json);
                }
            });
        },

        /*********解析渠道汇总JSON**********/
        parseSummary(json) {
            try {
                var list = JSON.parse(json || '[]');
                return Array.isArray(list) ? list : [];
            } catch (e) {
                return [];
            }
        },

        /*********格式化价格**********/
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        }
    }
}
</script>

<style scoped>
.m-detail-tag {
    gap: 8px;
    font-size: 14px;
    font-weight: bold;
}

.m-detail-saas {
    font-size: 12px;
    font-weight: normal;
    color: #999;
}

.m-detail-box {
    padding: 10px;
}
</style>
